/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Labs_Predictor_TimeInputs */

const en_ui_labs_predictor_time = /** @type {(inputs: Ui_Labs_Predictor_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time`)
};

const de_ui_labs_predictor_time = /** @type {(inputs: Ui_Labs_Predictor_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeit`)
};

/**
* | output |
* | --- |
* | "Time" |
*
* @param {Ui_Labs_Predictor_TimeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_labs_predictor_time = /** @type {((inputs?: Ui_Labs_Predictor_TimeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Labs_Predictor_TimeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_labs_predictor_time(inputs)
	return de_ui_labs_predictor_time(inputs)
});